<template>
  <form @submit.prevent="save">
    <div>
      You can add existing recordings from VoiceVibes to your assignment so your users can playback and hear the recording.
      <br><br>
      To add a recording to this assignment, first pick the user who owns the recording you wish to include:<br>

      <group-user-select
        :key="userKey"
        :groups="activeGroups"
        :users="filteredGroupMembers"
        mode="user"
        :multiple="false"
        @groupUserChange="setUser"
      />
    </div>
    <br>
    <div
      v-if="user"
    >
      Next, choose the recording you wish to include then click Save:<br>
      <div
        style="margin-left: 5px;"
      >
        <recording-select
          :recordings="recordings"
          :recording="null"
          :is-small="false"
          @loadRecording="setRecording"
        />
      </div>
      <div
        v-if="recording"
      >
        <br>
        <button
          id="attachmentSaveButton"
          type="button"
          class="btn btn-primary"
          @click="saveRecording"
        >
          Save
        </button>
      </div>
    </div>
  </form>
</template>


<script>
import GroupUserSelect from '../specials/GroupUserSelect';
import RecordingSelect from '../specials/RecordingSelect';

export default {
  components: {GroupUserSelect, RecordingSelect},
  data() {
    return {
      user: null,
      recording: null,
      recordings: [],
      errors: [],
      userKey: 1,
    };
  },
  computed: {
    filteredGroupMembers: {
      cache: false,
      get() {
        const gm = this._.cloneDeep(this.$store.getters.groupMembers);

        // Delete from gm everyone who does not have a recording
        this._.forEach(gm, (users, groupId) => {
          this._.forEach(users, (user, userId) => {
            let hasRecs = !!(this.sharedRecordings[groupId] && this.sharedRecordings[groupId][userId]);
            if (!hasRecs) {
              delete gm[groupId][userId];
            }
          });
        });
        return gm;
      }
    },
    activeGroups: {
      cache: false,
      get() {
        return this.$store.getters.activeGroups;
      }
    },
    groupMembers: {
      cache: false,
      get() {
        return this.$store.getters.groupMembers;
      }
    },
    sharedRecordings: {
      cache: false,
      get() {
        return this.$store.getters.groupRecordings;
      }
    },
    myRecordings: {
      cache: false,
      get() {
        return this._.filter(this.$store.getters.recordings, r => r.playbackUrl);
      }
    },
    me: {
      cache: false,
      get() {
        return this.$store.getters.user;
      }
    },
  },
  methods: {
    reset() {
      this.user = null;
      this.recording = null;
      this.userKey += 1;
      this.$forceUpdate();
    },
    setUser(user) {
      let recordings = [];

      this._.forEach(this.sharedRecordings, (group) => {
        for (let userId in group) {
          if (group[userId] && userId == user.id) {
            recordings = recordings.concat(group[userId]);
          }
        }
      });

      // Allow the user to pick their own recordings which may still be processing
      if (user.id == this.me.userId) {
        recordings = this.myRecordings;
      }

      this.recordings = this._.sortBy(
        recordings, r => -new Date(r.createdDate).getTime()
      );
      this.user = user;
    },
    setRecording(recording) {
      this.recording = recording;
    },
    saveRecording() {
      const attachment = {
        attachmentType: 'recording',
        recordingId: this.recording.recordingId,
        name: this.recording.title,
      };

      this.$emit('saveAttachment', {attachment});
      this.reset();
    }
  }
};
</script>
